export default __webpack_public_path__ + "static/media/memories.6de88164.png";